import { FC } from 'react';

import WorkTripsCalendarView from '../components/WorkTripsCalendarView';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => (
  <WorkTripsCalendarView
    Wrapper={InnerWrapper}
    entityName="work-trips-calendar"
    showUserAndGroupFilters
  />
);

export default Screen;
